// Game configuration types for the Critique & Coach mini-game editor

export interface AnswerOption {
  label: string; // A, B, C, D
  text: string;
  correct: boolean;
  feedback: string;
  rewrite?: string; // Optional example/rewrite
}
export interface Round {
  id: string;
  Statement: string; // Main scenario shown to player (e.g., "Outcome Goal: By the end of this quarter...")
  feedback: string; // Question asked (e.g., "Is anything amiss in this goal?")
  correctAnswer: string; // "STRONG" or "WEAK"
}

export interface StreakMessages {
  streak2: any;
  streak3: any;
  streak4: any;
  streak5: any;
}

export interface CongratulatoryMessage {
  minPercent: number;
  maxPercent: number;
  message: string;
}

export interface GameSettings {
  pointsPerCorrect: number;
  correctLabel: string;
  incorrectLabel: string;
  timerEnabled: boolean;
  timePerRound: number;
  allowReplay: boolean;
  streakMessages: any;
  congratulatoryMessages: CongratulatoryMessage[];
}

export interface GameConfig {
  version: number;
  title: string;
  subtitle: string;
  instructions: string;
  messageHeading: string;
  leftOptionLabel: string;
  statementLabel:string;
  rightOptionLabel: string;
  rounds: Round[];
  settings: GameSettings;
}

// export const DEFAULT_ROUNDS: Round[] = [
//   {
//     id: "round-1",
//     text: "",
//     correct: "WEAK",
//     why: "",
//   },
// ];

export const DEFAULT_CONFIG: GameConfig = {
  version: 1,
  title: "",
  subtitle: "",
  instructions: "Tap on Strong / Weak to classify, or use your keyboard arrows",
  messageHeading: "",
  leftOptionLabel: "WEAK",
  statementLabel:'',
  rightOptionLabel: "STRONG",
  rounds: [
    {
      id: "round-1",
      Statement: "",
      feedback: "",
      correctAnswer:""
    }
  ],
  settings: {
    pointsPerCorrect: 100,
    correctLabel: "Correct",
    incorrectLabel: "Not quite",
    timerEnabled: true,
    timePerRound: 30,
    allowReplay: true,
    streakMessages: {
      streak2: "👍 Nice!",
      streak3: "✨ Wow!",
      streak4: "👏 Unstoppable!",
      streak5: "🔥 PERFECT RUN!",
    },
    congratulatoryMessages: [
      { minPercent: 0, maxPercent: 33, message: "" },
      { minPercent: 34, maxPercent: 66, message: "" },
      { minPercent: 67, maxPercent: 100, message: "" },
    ],
  },
};